import { Controller } from "@hotwired/stimulus"
import React from "react"
import { createRoot } from "react-dom/client"
import FlowEditor from "../flow_editor/FlowEditor"

// The ONE React island (CLAUDE.md architecture mandate). This Stimulus
// controller is the Hotwire↔React bridge: it mounts the React Flow canvas onto
// a div, hands it the draft graph + save URL, and tears it down on disconnect
// so Turbo navigations don't leak roots.
export default class extends Controller {
  static targets = ["mount"]
  static values = { graph: Object, saveUrl: String, csrf: String }

  connect() {
    this.root = createRoot(this.mountTarget)
    this.root.render(
      React.createElement(FlowEditor, {
        graph: this.graphValue,
        saveUrl: this.saveUrlValue,
        csrf: this.csrfValue,
      })
    )
  }

  disconnect() {
    if (this.root) {
      // Defer so React isn't torn down mid-render during Turbo caching.
      const root = this.root
      this.root = null
      queueMicrotask(() => root.unmount())
    }
  }
}
